import React from "react";
import { NoPicture } from "@components/Common/SvgIcons";
import { t } from "i18next";
import { useSnapshot } from "valtio";
import { RefreshIcon, StyledIconButton } from "@aureskonnect/react-ui";
import {
    templateActions,
    templateStore,
} from "@pages/Applications/C&C/C&CSetup/templateStore";
import { useTemplateData } from "@constants/template";
import ColorSvgIcon from "@components/Common/SvgIcons/ColorSvgIcon";
import { SketchPicker } from "react-color";
import { deleteFile } from "../fileStore";
import { validUploadedTypes } from "../Website/constants";
import swal from "@sweetalert/with-react";

interface DesignDiversProps {
    path: string[];
    icone?: boolean;
    titleImage?: string;
    titleColorActivate?: boolean;
}

function DesignDivers({
    path = ["template", "SiteWeb", "Divers"],
    icone = false,
    titleImage = "LOGO",
    titleColorActivate = true,
}: DesignDiversProps) {
    const snap = useSnapshot(templateStore);
    const { getImageName, getImageUrl, iuud } = useTemplateData();
    const imageUrl = getImageUrl([...path.slice(1), "Icone"], iuud);
    const imageName = getImageName([...path.slice(1), "Icone"]);
    const titleColorPickerRef = React.useRef<HTMLDivElement>(null);
    const mainColorPickerRef = React.useRef<HTMLDivElement>(null);
    const fileInputRef = React.useRef<HTMLInputElement>(null);

    const [showTitleColorPicker, setShowTitleColorPicker] = React.useState(
        false
    );
    const [showMainColorPicker, setShowMainColorPicker] = React.useState(false);

    const getNestedValue = (subPath: string[]) => {
        try {
            let current = snap as any;
            for (const key of [...path, ...subPath]) {
                current = current[key];
                if (current === undefined) return null;
            }
            return current;
        } catch (error) {
            console.error("Error accessing nested property:", error);
            return null;
        }
    };

    const updateNestedValue = (subPath: string[], value: any) => {
        templateActions.updateTemplate([...path, ...subPath], value);
    };

    const initialTitleColor = getNestedValue(["CouleurTitre"]) || "black";
    const initialMainColor = getNestedValue(["CouleurPrincipale"]) || "black";

    const [titleColor, setTitleColor] = React.useState(initialTitleColor);
    const [mainColor, setMainColor] = React.useState(initialMainColor);

    const handleUpdateMainColor = (value: string) => {
        setMainColor(value);
        updateNestedValue(["CouleurPrincipale"], value);
    };

    const handleUpdateTitleColor = (value: string) => {
        setTitleColor(value);
        updateNestedValue(["CouleurTitre"], value);
    };

    const handleUpload = React.useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            const file = e.target.files?.[0];
            const input = e.target;

            if (file && !validUploadedTypes.includes(file.type)) {
                // Reset input to allow re-uploading the same invalid file
                input.value = "";

                return swal({
                    icon: "error",
                    content: <p>{t("File type is not valid")}!</p>,
                    buttons: false,
                    timer: 2000,
                });
            }
            if (!file) return;
            templateActions.updateMediaFile(
                [...path, "Icone"],
                "fileObject",
                file
            );
        },
        [path]
    );
    const handleReset = React.useCallback(
        (e) => {
            const emptyData = {
                Url: "",
                Name: "",
                Type: "",
                Extenxion: "",
            };
            templateActions.updateTemplate(
                path[path.length - 1] === "Icone" ? path : [...path, "Icone"],
                emptyData
            );
            const pathKey = path.join(".");
            deleteFile(pathKey);

            // Clear file input so same file can be re-selected
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
        },
        [path]
    );

    React.useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                titleColorPickerRef.current &&
                !titleColorPickerRef.current.contains(event.target as Node)
            ) {
                setShowTitleColorPicker(false);
            }
            if (
                mainColorPickerRef.current &&
                !mainColorPickerRef.current.contains(event.target as Node)
            ) {
                setShowMainColorPicker(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    React.useEffect(() => {
        const ensureAllPaths = async () => {
            const iconPath = [...path.slice(1), "Icone"];
            // Check if the path exists in the snapshot
            let current: any = snap.template;
            for (const key of iconPath) {
                if (current && key in current) {
                    current = current[key];
                } else {
                    current = null;
                    break;
                }
            }

            // If the path doesn't exist, initialize it
            if (!current) {
                await templateActions.ensurePathExists(iconPath, {
                    Url: "",
                    Name: "",
                    Type: "",
                    Extenxion: "",
                });
            }
        };

        if (icone) {
            ensureAllPaths();
        }
    }, [icone, path, snap]);

    return (
        <div
            className="mt-3 mx-2"
            style={{
                display: "flex",
                justifyContent: "space-between",
            }}
        >
            <h5 style={{ fontWeight: "bold" }}>{t("Design")}</h5>

            <div
                style={{
                    display: "flex",
                    width: "93%",
                    alignItems: "center",
                    justifyContent: "space-evenly",
                    marginTop: "10px",
                    flexWrap: "wrap",
                }}
            >
                <div
                    style={{
                        width: "20%",
                        display: "flex",
                        flexDirection: "column",
                        gap: "5px",
                    }}
                >
                    <div
                        className={icone ? "" : "not-allowed-icon__clz"}
                        style={{
                            width: "100%",
                            height: "100px",
                            borderRadius: "10px",
                            border: "1px solid #a19e9e",
                            background: "#f5f5f5",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#999",
                            fontSize: "12px",
                            position: "relative",
                        }}
                    >
                        {imageName !== "" && (
                            <StyledIconButton
                                title={t("Reset")}
                                outline={true}
                                variant="danger"
                                className="m-0 pme_btn_buttonReinitializeTemplate"
                                onClick={handleReset}
                                style={{
                                    position: "absolute",
                                    right: "0px",
                                    top: "0px",
                                }}
                            >
                                <RefreshIcon height={20} width={20} />
                            </StyledIconButton>
                        )}
                        <input
                            type="file"
                            accept="image/*"
                            className="file-input"
                            onChange={handleUpload}
                            id={`${path.join("-")}-upload`}
                            aria-label="Upload an image"
                            ref={fileInputRef}
                        />

                        <label
                            htmlFor={`${path.join("-")}-upload`}
                            style={{
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                            }}
                        >
                            <NoPicture
                                height="35px"
                                width="40px"
                                className="flag__clz"
                            />
                            <span>
                                {imageUrl !== "" ? imageName.slice(-15) : ""}
                            </span>
                        </label>
                    </div>
                    <span
                        style={{
                            fontSize: "14px",
                            textAlign: "center",
                        }}
                    >
                        {t(titleImage)}
                    </span>
                </div>

                <div
                    style={{
                        width: "20%",
                        display: "flex",
                        flexDirection: "column",
                        gap: "5px",
                    }}
                >
                    <div
                        style={{
                            width: "100%",
                            height: "100px",
                            borderRadius: "10px",
                            border: "1px solid #a19e9e",
                            background: "#f5f5f5",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#999",
                            fontSize: "12px",
                        }}
                    >
                        <span
                            style={{
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <div
                                style={{
                                    borderRadius: 3,
                                    width: 100,
                                    height: 30,
                                    backgroundColor: mainColor,
                                    marginRight: 10,
                                }}
                            ></div>
                            <ColorSvgIcon
                                onClick={() =>
                                    setShowMainColorPicker(!showMainColorPicker)
                                }
                                height="35px"
                                width="40px"
                                color={mainColor}
                            />
                            {showMainColorPicker && (
                                <div
                                    tabIndex={0}
                                    style={{
                                        position: "fixed",
                                        zIndex: 2,
                                    }}
                                    ref={mainColorPickerRef}
                                >
                                    <SketchPicker
                                        color={mainColor}
                                        onChange={(color) => {
                                            handleUpdateMainColor(color.hex);
                                        }}
                                    />
                                </div>
                            )}
                        </span>
                    </div>
                    <span
                        style={{
                            fontSize: "14px",
                            textAlign: "center",
                        }}
                    >
                        {t("Main color")}
                    </span>
                </div>

                <div
                    style={{
                        width: "20%",
                        display: "flex",
                        flexDirection: "column",
                        gap: "5px",
                    }}
                >
                    <div
                        className={
                            titleColorActivate ? "" : "not-allowed-icon__clz"
                        }
                        style={{
                            width: "100%",
                            height: "100px",
                            borderRadius: "10px",
                            border: "1px solid #a19e9e",
                            background: "#f5f5f5",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#999",
                            fontSize: "12px",
                        }}
                    >
                        <span
                            style={{
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <div
                                style={{
                                    borderRadius: 3,
                                    width: 100,
                                    height: 30,
                                    backgroundColor: titleColor,
                                    marginRight: 10,
                                }}
                            ></div>
                            <ColorSvgIcon
                                onClick={() =>
                                    setShowTitleColorPicker(
                                        !showTitleColorPicker
                                    )
                                }
                                height="35px"
                                width="40px"
                                color={titleColor}
                            />
                            {showTitleColorPicker && (
                                <div
                                    tabIndex={0}
                                    style={{
                                        position: "fixed",
                                        zIndex: 2,
                                    }}
                                    ref={titleColorPickerRef}
                                >
                                    <SketchPicker
                                        color={titleColor}
                                        onChange={(color) => {
                                            handleUpdateTitleColor(color.hex);
                                        }}
                                    />
                                </div>
                            )}
                        </span>
                    </div>
                    <span
                        style={{
                            fontSize: "14px",
                            textAlign: "center",
                        }}
                    >
                        {t("Color of titles")}
                    </span>
                </div>

                <div
                    style={{
                        width: "20%",
                        display: "flex",
                        flexDirection: "column",
                        gap: "5px",
                    }}
                >
                    <div
                        className="not-allowed-icon__clz"
                        style={{
                            width: "100%",
                            height: "100px",
                            borderRadius: "10px",
                            border: "1px solid #a19e9e",
                            background: "#f5f5f5",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#999",
                            fontSize: "12px",
                        }}
                    >
                        <select
                            style={{
                                width: "70%",
                                height: "40%",
                                cursor: "pointer",
                                borderRadius: "10px",
                            }}
                            onChange={(e) => {}}
                        >
                            <option value="">--Please choose type--</option>
                            <option value="Nunito Sans">Nunito Sans</option>
                            <option value="Arial">Arial</option>
                            <option value="Roboto">Roboto</option>
                            <option value="Times New Roman">
                                Times New Roman
                            </option>
                        </select>
                    </div>
                    <span
                        style={{
                            fontSize: "14px",
                            textAlign: "center",
                        }}
                    >
                        {t("Type of writing")}
                    </span>
                </div>
            </div>
        </div>
    );
}

export default DesignDivers;
